/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMyUserDetails } from '../fn/my/get-my-user-details';
import { GetMyUserDetails$Params } from '../fn/my/get-my-user-details';
import { updateLastLoginUser } from '../fn/my/update-last-login-user';
import { UpdateLastLoginUser$Params } from '../fn/my/update-last-login-user';
import { updateMyUserDetails } from '../fn/my/update-my-user-details';
import { UpdateMyUserDetails$Params } from '../fn/my/update-my-user-details';
import { UserDetailsResponse } from '../models/user-details-response';

@Injectable({ providedIn: 'root' })
export class MyService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMyUserDetails()` */
  static readonly GetMyUserDetailsPath = '/api/my/user-details';

  /**
   * Get My User Details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyUserDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyUserDetails$Response(params?: GetMyUserDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsResponse>> {
    return getMyUserDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * Get My User Details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMyUserDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyUserDetails(params?: GetMyUserDetails$Params, context?: HttpContext): Observable<UserDetailsResponse> {
    return this.getMyUserDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDetailsResponse>): UserDetailsResponse => r.body)
    );
  }

  /** Path part for operation `updateMyUserDetails()` */
  static readonly UpdateMyUserDetailsPath = '/api/my/user-details';

  /**
   * Update My User Details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMyUserDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMyUserDetails$Response(params: UpdateMyUserDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsResponse>> {
    return updateMyUserDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * Update My User Details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMyUserDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMyUserDetails(params: UpdateMyUserDetails$Params, context?: HttpContext): Observable<UserDetailsResponse> {
    return this.updateMyUserDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDetailsResponse>): UserDetailsResponse => r.body)
    );
  }

  /** Path part for operation `updateLastLoginUser()` */
  static readonly UpdateLastLoginUserPath = '/api/my/user/lastLogin';

  /**
   * Update Last Login User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLastLoginUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateLastLoginUser$Response(params?: UpdateLastLoginUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateLastLoginUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Last Login User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLastLoginUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateLastLoginUser(params?: UpdateLastLoginUser$Params, context?: HttpContext): Observable<void> {
    return this.updateLastLoginUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
